// Load Groups translations for React Admin resource
export const loadGroupsResource = {
  name: '負載組',
  fields: {
    id: 'ID',
    name: '名稱',
    site: '充電站',
    siteId: '充電站',
    siteName: '充電站名稱',
    description: '描述',
    location: '位置',
    maxPower: '最大功率 (kW)',
    currentPower: '目前功率 (kW)',
    powerUsage: '功率使用',
    voltage: '電壓',
    maxCurrent: '最大電流 (A)',
    phase: '相位',
    priorityLevel: '優先級別',
    loadBalancingEnabled: '啟用負載平衡',
    loadBalancing: '負載平衡',
    status: '狀態',
    lastStatusUpdate: '最後狀態更新',
    chargers: '充電樁',
    utilized: '使用率',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    ocppServerId: 'OCPP 伺服器',
    lmsTemplateId: 'LMS 範本',
  },
};

// Custom load groups translations for components
export const loadGroups = {
  priority: '優先級',
  noChargers: '此負載組沒有分配充電樁',
  statuses: {
    active: '啟用',
    inactive: '停用',
    maintenance: '維護中',
  },
  phases: {
    single: '單相',
    three: '三相',
  },
  sections: {
    basic: '基本資訊',
    electrical: '電氣配置',
    powerManagement: '電力管理',
    settings: '設定',
    statistics: '統計總覽',
    info: '負載組資訊',
    chargers: '分配的充電樁',
  },
  tabs: {
    details: '詳細資訊',
    chargers: '充電樁',
  },
  stats: {
    chargers: '充電樁',
    activeChargers: '使用中充電樁',
    powerUtilization: '功率使用率',
    capacity: '容量分配',
    allocated: '已分配',
  },
  list: {
    title: '負載組',
    filters: {
      search: '按名稱搜尋',
    },
  },
  create: {
    title: '建立負載組',
    subtitle: '配置新的負載組以進行電力管理',
    backToList: '返回負載組',
  },
  edit: {
    title: '編輯負載組',
    subtitle: '管理負載組配置和電力分配',
    backToList: '返回負載組',
  },
  delete: {
    sectionTitle: '危險區域',
    title: '刪除負載組',
    content: '您確定要刪除此負載組嗎？此操作無法復原。',
    hasChargersContent: '此負載組無法刪除，因為有充電樁連接。請在刪除前重新分配或移除所有充電樁。',
    warning: '警告：此操作是永久性的！',
    message: '您即將刪除負載組',
    prompt: '要確認刪除，請輸入',
    promptBelow: '在下面的欄位中：',
    typePlaceholder: '輸入「%{name}」以確認',
    nameDoesNotMatch: '名稱不匹配',
    button: '刪除負載組',
  },
  actions: {
    create: '建立負載組',
    save: '儲存變更',
    delete: '刪除負載組',
  },
  helpers: {
    name: '站點內的唯一名稱',
    site: '此負載組所在的充電站',
    siteCannotChange: '建立後無法更改充電站',
    description: '此負載組的選擇性描述',
    location: '站點內的具體位置（例如：「第二層停車場」）',
    phase: '電氣相位配置',
    voltage: '工作電壓（伏特）',
    maxCurrent: '最大電流容量（安培）',
    maxPower: '此組可提供的最大功率',
    priorityLevel: '1（最高）到 10（最低）- 用於負載調節',
    status: '目前運作狀態',
    ocppServer: '管理此組的 OCPP 伺服器',
    lmsTemplate: '負載管理系統範本（選填）',
  },
  validation: {
    nameTooLong: '名稱太長',
    descriptionTooLong: '描述太長',
    locationTooLong: '位置太長',
    voltageTooLow: '電壓太低',
    voltageTooHigh: '電壓太高',
    currentNegative: '電流必須為正數',
    currentTooHigh: '電流太高',
    powerNegative: '功率必須為正數',
    powerTooLow: '功率必須至少為 1 kW',
    powerTooHigh: '功率太高',
    powerBelowChargers: '無法將最大功率降低到 %{minPower}kW 以下（充電樁總容量）',
    priorityTooLow: '優先級必須至少為 1',
    priorityTooHigh: '優先級不能超過 10',
    singlePhaseVoltage: '單相電壓不能超過 480V',
  },
  warnings: {
    electricalChanges: '電氣配置的變更可能會影響連接的充電樁',
    singlePhaseVoltage: '單相配置限制為 480V',
    highUtilization: '此負載組接近容量上限。請考慮重新分配充電樁或增加容量。',
  },
  info: {
    priorityNote: '數字越小優先級越高。在負載調節期間，低優先級組會先減少功率。',
    calculatedPower: '計算功率容量：%{power} kW',
  },
  notifications: {
    created: '負載組建立成功',
    updated: '負載組更新成功',
    deleted: '負載組刪除成功',
    deleteError: '刪除負載組失敗',
  },
};